import React, { useEffect, useState, useRef } from 'react';
import './style.css';
import placeHolderProdImage from '../../prod.png';
import { Grid } from '@material-ui/core';
import AnimatedText from '../AnimatedText';


const ProductDetails = (props) => {
  const {product: detail, isMobile} = props;
  const navRef = useRef(null);

  console.log("Prop", props);
  console.log("state", detail);
  
  if (!detail || detail.length === 0) {
    return <></>;
  }
  return (
    
      isMobile ? (
      <div className="product-details" style={{ paddingLeft: '10px', paddingRight: '10px'}}>
        {/* <div className="product-row" style={{ marginBottom: '0px', alignSelf: 'center'}}>
              <h3 className="product-name" style={{backgroundColor: 'yellow'}}>{detail.name}</h3>
        </div> */}
        <>
          <div className="product-row">
            {/* <img src={detail.image ? detail.image : placeHolderProdImage} /> */}
            <div className="product-details">
              <h3 className="product-name">
                <AnimatedText text={`${detail.name}`} />
              </h3>
              <div style={{ marginTop: '10px' }}>
                <div dangerouslySetInnerHTML={{ __html: detail.description }} />
              </div>
            </div>
          </div>
        </>
      </div>) : (
        <div className="product-details"> 
          <h3 className="product-name">
                <AnimatedText text={`${detail.name}`} />
          </h3>
          <div style={{ marginTop: '10px' }}>
            <AnimatedText text={`${detail.description}`} />
          </div>
        </div>
      )
  );
}
  
export default ProductDetails;